// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"b5e7eb0c","177":"36220dcb","228":"ca87a250","465":"ca87a250","474":"0c3149c8","601":"79afa45d","866":"36220dcb","898":"b5e7eb0c"}[chunkId] + ".css";
};